// @flow

import React from 'react'
import {get} from 'lodash'

import Medicine from './Medicine'

import css from './MedicineList.css'

type Props = {
  medicineAmount: number,
  medicines: Array<Object>,
  isFetching: boolean,
  showQrCodeText: boolean,
  urlKeyword: ?string,
  showLoadMore: boolean,
  onLoadMore: Function,
  showMedicineInfo: boolean,
}

const printPage = () => {
  window.print()
}

const MedicineList = ({
  medicineAmount,
  medicines,
  isFetching,
  urlKeyword,
  showQrCodeText,
  showLoadMore,
  onLoadMore,
  showMedicineInfo,
}: Props) => {
  if (isFetching) {
    return (
      <div className={css.component}>
        <div className={css.title}>Ladataan ...</div>
      </div>
    )
  }
  return (
    <div className={css.component}>
      {urlKeyword && (
        <div className={css.title}>Tulokset hakusanalla: {urlKeyword} ({medicineAmount})</div>
      )}
      {showQrCodeText && <div className={css.title}>Tulokset QR-koodilla ({medicineAmount})</div>}

      {medicines.map((medicine, index) => (
        <Medicine
          key={index}
          isMissing={get(medicine, 'isMissing')}
          name={get(medicine, 'name')}
          intensity={get(medicine, 'intensity')}
          pharmaceuticalForm={get(medicine, 'pharmForm')}
          atc={get(medicine, 'atc')}
          activeIncredient={get(medicine, 'activeIncr')}
          vnr={get(medicine, 'vnr')}
          salesPermit={get(medicine, 'salesPermit')}
          dimensions={get(medicine, 'dimensions')}
          colour={get(medicine, 'colour')}
          storageConditions={get(medicine, 'storCond')}
          breakline={get(medicine, 'breakline')}
          markings={get(medicine, 'markings')}
          note={get(medicine, 'note')}
          leaflet={get(medicine, 'leaflet')}
          imageUrl={get(medicine, 'imageUrl')}
          showMedicineInfo={showMedicineInfo}
        />
      ))}
      {!medicines.length && <p>Tuotetieto puuttuu</p>}
      {showLoadMore && (
        <a className={css.showMoreLink} onClick={() => onLoadMore()}>
          Näytä lisää +
        </a>
      )}
      {medicines.length > 0 && (
        <button className={css.button} onClick={printPage}>
          Tulosta kaikki tuotetiedot
        </button>
      )}
    </div>
  )
}

export default MedicineList



// WEBPACK FOOTER //
// ./src/homepage/components/MedicineList.js